import RelationshipDetail from './RelationshipDetail';

export default RelationshipDetail;
